import React from 'react';
import { ArrowRight, Truck, Star, MapPin } from 'lucide-react';
import { SHOP_URL } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* soft decorative blobs */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-[#E9D4CE]/50 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -left-32 w-[380px] h-[380px] rounded-full bg-[#DfE6Dc]/60 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/70 border border-[#E5DCCF] px-4 py-1.5 text-[13px] text-[#3D5142] mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#C4715A]" /> Same-day delivery across the Bay Area
            </span>
            <h1 className="font-serif-display text-[#26302a] text-[44px] leading-[1.05] sm:text-[56px] lg:text-[64px] font-semibold">
              Fresh flowers,
              <span className="block italic text-[#C4715A]">beautifully delivered.</span>
            </h1>
            <p className="mt-6 text-[17px] leading-relaxed text-[#5A554C] max-w-xl">
              Your local florist for <strong className="font-semibold text-[#3D5142]">same-day flower delivery in Menlo Park and surrounding areas</strong>. Hand-crafting stunning arrangements for every occasion for over 30 years — order today and brighten someone's day.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 rounded-full bg-[#3D5142] hover:bg-[#31412f] text-white text-[16px] font-medium px-7 py-3.5 transition-colors shadow-md">
                Shop the Collection
                <ArrowRight className="w-4.5 h-4.5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a href="#products" className="inline-flex items-center gap-2 rounded-full border border-[#C9BBA9] hover:border-[#3D5142] text-[#3D5142] text-[16px] font-medium px-7 py-3.5 transition-colors">
                Browse Designs
              </a>
            </div>

            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4">
              {[
                { icon: Truck, label: 'Same-Day Delivery' },
                { icon: Star, label: '5-Star Rated Florist' },
                { icon: MapPin, label: 'Local Redwood City' },
              ].map((f) => (
                <div key={f.label} className="flex items-center gap-2.5 text-[14px] text-[#5A554C]">
                  <span className="w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-sm border border-[#EFE8DD]">
                    <f.icon className="w-4 h-4 text-[#3D5142]" />
                  </span>
                  {f.label}
                </div>
              ))}
            </div>
          </div>

          {/* Image collage */}
          <div className="relative">
            <div className="relative rounded-[28px] overflow-hidden shadow-2xl aspect-[4/5] max-w-md ml-auto">
              <img
                src="https://images.unsplash.com/photo-1487530811176-3780de880c2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxmbG9yaXN0JTIwYm91cXVldHxlbnwwfHx8fDE3ODYxNTMzODd8MA&ixlib=rb-4.1.0&q=85"
                alt="Fresh floral bouquet"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="animate-floaty absolute -bottom-6 -left-4 sm:left-2 w-40 h-52 rounded-2xl overflow-hidden shadow-xl border-4 border-[#FBF8F4] hidden sm:block">
              <img
                src="https://images.unsplash.com/photo-1531058240690-006c446962d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxmbG93ZXIlMjBzaG9wfGVufDB8fHx8MTc4NjE1MzM4N3ww&ixlib=rb-4.1.0&q=85"
                alt="Florist at work"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-4 left-4 sm:left-0 bg-white rounded-2xl shadow-xl px-5 py-3.5 border border-[#EFE8DD] hidden sm:flex items-center gap-3">
              <div className="flex -space-x-1">
                {[0,1,2,3,4].map(i => <Star key={i} className="w-4 h-4 fill-[#E0A93B] text-[#E0A93B]" />)}
              </div>
              <span className="text-[13px] text-[#4A4A45] font-medium">200+ happy customers</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
